var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computedFrom } from 'aurelia-binding';
import { bindable, customElement } from 'aurelia-templating';
import { autoinject, transient } from "aurelia-dependency-injection";
import { Reflection } from '../../../utilities/reflection';
var HueSlider = /** @class */ (function () {
    function HueSlider(element) {
        this.element = element;
        this.offsetWidth = 0;
        this.leftPosition = 0;
        this.color = "000000";
        this.positionSlider = -1;
    }
    HueSlider.prototype.positionSliderChanged = function (newValue, oldValue) {
        var rgb = this.hslToRgb(newValue, 1, 0.5);
        this.color = this.rgb2hex(rgb[0], rgb[1], rgb[2]);
        var width = this.offsetWidth > 0 ? this.offsetWidth : this.container.offsetWidth;
        if ((this.offsetWidth == 0 || this.container.offsetWidth != this.offsetWidth) && this.container.offsetWidth > 0) {
            this.offsetWidth = this.container.offsetWidth;
        }
        this.leftPosition = newValue * width / 360 - this.sliderPointer.offsetWidth / 2;
        var paramsEvent = { detail: { value: newValue }, bubbles: true };
        var changePositionEvent = new CustomEvent("position-changed", paramsEvent);
        this.element.dispatchEvent(changePositionEvent);
    };
    HueSlider.prototype.colorChanged = function (newValue, oldValue) {
        var paramsEvent = { detail: { value: newValue }, bubbles: true };
        var changeColorEvent = new CustomEvent("value-changed", paramsEvent);
        this.element.dispatchEvent(changeColorEvent);
    };
    HueSlider.prototype.bind = function () {
        if (!this.positionSlider || this.positionSlider < 0) {
            this.positionSlider = 0;
        }
    };
    Object.defineProperty(HueSlider.prototype, "getHslColor", {
        get: function () {
            return 'hsl(' + this.positionSlider + ',100%,50%)';
        },
        enumerable: false,
        configurable: true
    });
    HueSlider.prototype.attached = function () {
        var _this = this;
        var prevX = 0;
        var mouseMoveFunc = function (e) {
            if (e.pageX !== prevX) {
                prevX = e.pageX;
                var rect = _this.container.getBoundingClientRect();
                var width = rect.width;
                var x = e.pageX - rect.left;
                x = x <= 0 ? 0 + 1 : (x >= width ? width - 1 : x);
                _this.leftPosition = x - _this.sliderPointer.offsetWidth / 2;
                _this.positionSlider = 360 * ((x) / width);
            }
        };
        var mouseUpFunc = function (e) {
            document.removeEventListener('mousemove', mouseMoveFunc);
        };
        var mouseDownFunc = function (e) {
            var rect = _this.container.getBoundingClientRect();
            var width = rect.width;
            var x = e.pageX - rect.left;
            x = x <= 0 ? 0 + 1 : (x >= width ? width - 1 : x);
            _this.leftPosition = x - _this.sliderPointer.offsetWidth / 2;
            _this.positionSlider = 360 * ((x) / width);
            document.addEventListener('mousemove', mouseMoveFunc);
        };
        this.sliderPointer.addEventListener('mousedown', mouseDownFunc);
        this.container.addEventListener('mousedown', mouseDownFunc);
        document.addEventListener('mouseup', mouseUpFunc);
    };
    HueSlider.prototype.hslToRgb = function (hue, saturation, lightness) {
        // based on algorithm from http://en.wikipedia.org/wiki/HSL_and_HSV#Converting_to_RGB
        if (hue === undefined) {
            return [0, 0, 0];
        }
        var chroma = (1 - Math.abs((2 * lightness) - 1)) * saturation;
        var huePrime = hue / 60;
        var secondComponent = chroma * (1 - Math.abs((huePrime % 2) - 1));
        huePrime = Math.floor(huePrime);
        var red;
        var green;
        var blue;
        if (huePrime === 0) {
            red = chroma;
            green = secondComponent;
            blue = 0;
        }
        else if (huePrime === 1) {
            red = secondComponent;
            green = chroma;
            blue = 0;
        }
        else if (huePrime === 2) {
            red = 0;
            green = chroma;
            blue = secondComponent;
        }
        else if (huePrime === 3) {
            red = 0;
            green = secondComponent;
            blue = chroma;
        }
        else if (huePrime === 4) {
            red = secondComponent;
            green = 0;
            blue = chroma;
        }
        else if (huePrime === 5) {
            red = chroma;
            green = 0;
            blue = secondComponent;
        }
        var lightnessAdjustment = lightness - (chroma / 2);
        red += lightnessAdjustment;
        green += lightnessAdjustment;
        blue += lightnessAdjustment;
        return [Math.round(red * 255), Math.round(green * 255), Math.round(blue * 255)];
    };
    ;
    HueSlider.prototype.rgb2hex = function (red, green, blue) {
        var rgb = blue | (green << 8) | (red << 16);
        return (0x1000000 + rgb).toString(16).slice(1);
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], HueSlider.prototype, "color", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], HueSlider.prototype, "positionSlider", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.positionSlider; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], HueSlider.prototype, "getHslColor", null);
    HueSlider = __decorate([
        autoinject(),
        transient(),
        customElement('hue-slider'),
        __metadata("design:paramtypes", [Element])
    ], HueSlider);
    return HueSlider;
}());
export { HueSlider };
